import { Injectable } from '@angular/core';
import type { MapboxMap } from '@polaris-customerweb/sharedcomponents.core';
import { MapService } from './map.service';

@Injectable({ providedIn: 'root' })
export class HeatmapService {
    layerIds: string[] = [];
    private layerKey = 'heatmap';

    constructor(private mapService: MapService) {}

    addSources(mapboxMap: MapboxMap) {
        this.layerIds = this.mapService
            .getLayerIds(mapboxMap)
            .filter((layerId) => layerId.toLowerCase().includes(this.layerKey));
    }

    setVisibility(mapboxMap: MapboxMap, visible: boolean) {
        if (visible) {
            this.layerIds.forEach((layerId) => {
                this.mapService.showLayer(mapboxMap, layerId);
            });
        } else {
            this.layerIds.forEach((layerId) => {
                this.mapService.hideLayer(mapboxMap, layerId);
            });
        }
    }
}
